import React from "react";
import { Target, Eye, HeartHandshake } from "lucide-react";

const MissionVision = () => {
  const items = [
    {
      icon: <Target size={26} />,
      title: "MISSION",
      text: "Empowering learners with hands-on industrial automation training to achieve real-world engineering excellence.",
    },
    {
      icon: <Eye size={26} />,
      title: "VISION",
      text: "To be a global leader in automation education, shaping future-ready engineers for Industry 4.0.",
    },
    {
      icon: <HeartHandshake size={26} />,
      title: "VALUE",
      text: "Building lasting trust through quality training, transparency, and unwavering learner commitment.",
    },
  ];

  return (
    <div style={styles.container}>
      <span style={styles.eyebrow}>Why Choose IIA</span>
      <h2 style={styles.heading}>
        <span style={{ color: "#0f172a" }}>Our </span>
        <span style={styles.highlight}>Commitments</span>
      </h2>
      <p style={styles.subheading}>
        Guiding principles that shape every program, lab, and mentorship
        session at IIA.
      </p>

      <div style={styles.cardWrapper}>
        {items.map((item, index) => (
          <div key={index} className="commitCard">
            <div className="cardIconWrap">{item.icon}</div>
            <div className="cardAccent" />
            <h3 className="cardTitle">{item.title}</h3>
            <p className="cardText">{item.text}</p>
          </div>
        ))}
      </div>

      <style>{`
        .commitCard {
          position: relative;
          background-color: #ffffff;
          width: 320px;
          min-height: 210px;
          border-radius: 16px;
          padding: 32px 28px 26px;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);
          border: 1px solid #eef2f7;
          box-sizing: border-box;
          transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
        }

        .commitCard:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(15, 23, 42, 0.16);
          border-color: #ffd8a8;
        }

        .cardIconWrap {
          width: 52px;
          height: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          background: linear-gradient(135deg, #eff6ff, #fff4ec);
          color: #1d4ed8;
          margin-bottom: 18px;
        }

        .cardAccent {
          width: 42px;
          height: 4px;
          background: linear-gradient(to right, #1d4ed8, #f7941d);
          border-radius: 2px;
          margin-bottom: 16px;
        }

        .cardTitle {
          font-size: 18px;
          font-weight: 800;
          letter-spacing: 1px;
          color: #0f172a;
          margin: 0 0 10px 0;
          font-family: 'Segoe UI', Arial, sans-serif;
        }

        .cardText {
          font-size: 14px;
          line-height: 1.65;
          color: #64748b;
          margin: 0;
          font-family: 'Segoe UI', Arial, sans-serif;
        }

        @media (max-width: 900px) {
          .commitCard {
            width: 270px;
          }
        }

        @media (max-width: 768px) {
          h2 {
            font-size: 26px !important;
            letter-spacing: 0px !important;
          }
          .commitCard {
            width: 90%;
            max-width: 360px;
            min-height: unset;
            padding: 26px 22px 22px;
          }
          .cardIconWrap {
            width: 46px;
            height: 46px;
          }
          .cardTitle {
            font-size: 16px;
          }
          .cardText {
            font-size: 13px;
          }
        }

        @media (max-width: 420px) {
          .commitCard {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    padding: "20px 20px",
    backgroundColor: "#ffffff",
    textAlign: "center",
  },
  eyebrow: {
    display: "inline-block",
    fontSize: "12px",
    fontWeight: "700",
    letterSpacing: "1.5px",
    color: "#1d4ed8",
    background: "#eff6ff",
    padding: "5px 16px",
    borderRadius: "20px",
    textTransform: "uppercase",
    marginBottom: "14px",
  },
  cardWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "26px",
    maxWidth: "1100px",
    margin: "0 auto",
  },
  heading: {
    textAlign: "center",
    fontSize: "36px",
    fontWeight: "800",
    marginBottom: "10px",
    letterSpacing: "0.5px",
    fontFamily: "'Segoe UI', Arial, sans-serif",
  },
  subheading: {
    fontSize: "14px",
    color: "#64748b",
    maxWidth: "480px",
    margin: "0 auto 40px",
    lineHeight: "1.6",
    fontFamily: "'Segoe UI', Arial, sans-serif",
  },
  highlight: {
    background: "linear-gradient(to right, #1d4ed8, #f7941d)",
    WebkitBackgroundClip: "text",
    backgroundClip: "text",
    color: "transparent",
  },
};

export default MissionVision;